var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", { ref: "modal", attrs: { heading: "Pass Applicant" } }, [
    _c("div", { staticClass: "mb-4" }, [
      _c("h5", [
        _vm._v("You are moving this candidate to Loading Offer"),
        _vm.enableSendToSage
          ? _c("span", [
              _vm._v(", would you like to Send this Candidate to Sage?")
            ])
          : _c("span", { staticStyle: { color: "red" } }, [
              _vm._v(
                " but please note this candidate will not be sent to Sage. Please check that the correct External Req # and Sage Req ID are linked to this candidate application, and retry sending to Sage"
              )
            ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "grid-x grid-padding-x align-right" }, [
      _c("div", { staticClass: "cell shrink" }, [
        _vm.enableSendToSage
          ? _c(
              "button",
              {
                staticClass: "button",
                attrs: { type: "button" },
                on: { click: _vm.passSendToSage }
              },
              [_vm._v("Send to Sage")]
            )
          : _c(
              "button",
              {
                staticClass: "button disabled",
                attrs: {
                  disabled: "",
                  title:
                    "You can not Send to Sage, please check that the correct External Req # and Sage Req ID are linked to this candidate application before trying again"
                }
              },
              [_vm._v("Send to Sage")]
            )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell shrink" }, [
        _vm.enableSendToSage
          ? _c(
              "button",
              {
                staticClass: "button warning",
                attrs: { type: "button" },
                on: { click: _vm.passOnly }
              },
              [
                _vm._v(
                  "\n                No do not send to Sage, just to Loading Offer\n            "
                )
              ]
            )
          : _c(
              "button",
              {
                staticClass: "button warning",
                attrs: { type: "button" },
                on: { click: _vm.passOnly }
              },
              [_vm._v("\n                Move to Loading offer\n            ")]
            )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-742eae09", { render: render, staticRenderFns: staticRenderFns })
  }
}